export default [
    {
        path: 'permissions',
        component: () =>
            import('@/views/permissions/components/PermissionsWrapper.vue'),
        children: [
            {
                path: "",
                name: "permissions",
                component: () => import("@/views/permissions/PermissionSearch.vue"),
            },
            {
                path: "/permissions/new",
                name: "newpermissions",
                component: () => import("@/views/permissions/PermissionSearch.vue"),
            },
            {
                path: "/permissions/:permissionId?",
                name: "editpermissions",
                component: () => import("@/views/permissions/PermissionDetail.vue"),
                props:true
            },

        ]
    }
]